
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigResponse} from './ConfigResponse';
import {FieldModelConfigResponse} from './ConfigResponse';
import {ConfigHistory} from './ConfigHistory';
import {FieldModelConfigHistory} from './ConfigHistory';

/**
 * ConfigHistoryResponse struct
 */
class ConfigHistoryResponse extends ConfigResponse {
  /**
   * Initialize struct
   * @param {!ConfigResponse=} parent
   * @param {!Array=} history
   * @constructor
   */
  constructor (parent = new ConfigResponse(), history = []) {
    super()
    super.copy(parent)
    this.History = history
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ConfigHistoryResponse}
   * @param {!ConfigHistoryResponse} other Other struct
   * @returns {!ConfigHistoryResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.History != null) {
      this.History = []
      for (let item of other.History) {
        if (item != null) {
          let tempItem
          tempItem = ConfigHistory.fromObject(item)
          this.History.push(tempItem)
        } else {
          this.History.push(null)
        }
      }
    } else {
      this.History = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ConfigHistoryResponse}
   * @returns {!ConfigHistoryResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ConfigHistoryResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ConfigHistoryResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ConfigHistoryResponse}
   * @param {!ConfigHistoryResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ConfigHistoryResponse)) {
      throw new TypeError('Instance of ConfigHistoryResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ConfigHistoryResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      History: ((this.History != null) ? Array.from(this.History, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ConfigHistoryResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ConfigHistoryResponse} other Object value
   * @returns {!ConfigHistoryResponse} Created struct
   */
  static fromObject (other) {
    return new ConfigHistoryResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ConfigHistoryResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ConfigHistoryResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ConfigHistoryResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 1023
  }
}

export { ConfigHistoryResponse };

/**
 * Fast Binary Encoding ConfigHistoryResponse field model
 */
class FieldModelConfigHistoryResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigResponse(buffer, 4 + 4)
    this.History = new fbe.FieldModelVector(new FieldModelConfigHistory(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the ConfigResponse field model
   * @this {!FieldModelConfigHistoryResponse}
   * @returns {!FieldModelConfigResponse} ConfigResponse field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelConfigHistoryResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelConfigHistoryResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.History.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelConfigHistoryResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.History.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelConfigHistoryResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelConfigHistoryResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelConfigHistoryResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 1023
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelConfigHistoryResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelConfigHistoryResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.History.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.History.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.History.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelConfigHistoryResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelConfigHistoryResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelConfigHistoryResponse}
   * @param {!ConfigHistoryResponse} fbeValue Default value, defaults is new ConfigHistoryResponse()
   * @returns {!ConfigHistoryResponse} ConfigHistoryResponse value
   */
  get (fbeValue = new ConfigHistoryResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelConfigHistoryResponse}
   * @param {!ConfigHistoryResponse} fbeValue ConfigHistoryResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.History.fbeSize) <= fbeStructSize) {
      this.History.get(fbeValue.History)
    } else {
      fbeValue.History.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.History.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelConfigHistoryResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelConfigHistoryResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelConfigHistoryResponse}
   * @param {!ConfigHistoryResponse} fbeValue ConfigHistoryResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelConfigHistoryResponse}
   * @param {ConfigHistoryResponse} fbeValue ConfigHistoryResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.History.set(fbeValue.History)
  }
}

export { FieldModelConfigHistoryResponse };

/**
 * Fast Binary Encoding ConfigHistoryResponse model
 */
class ConfigHistoryResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelConfigHistoryResponse(this.buffer, 4)
  }

  /**
   * Get the ConfigHistoryResponse model
   * @this {!ConfigHistoryResponseModel}
   * @returns {!FieldModelConfigHistoryResponse} model ConfigHistoryResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ConfigHistoryResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ConfigHistoryResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ConfigHistoryResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ConfigHistoryResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelConfigHistoryResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ConfigHistoryResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ConfigHistoryResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ConfigHistoryResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ConfigHistoryResponseModel}
   * @param {!ConfigHistoryResponse} value ConfigHistoryResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ConfigHistoryResponseModel}
   * @param {!ConfigHistoryResponse} value ConfigHistoryResponse value, defaults is new ConfigHistoryResponse()
   * @return {!object} Deserialized ConfigHistoryResponse value and its size
   */
  deserialize (value = new ConfigHistoryResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ConfigHistoryResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ConfigHistoryResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ConfigHistoryResponseModel}
   * @param {!number} prev Previous ConfigHistoryResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ConfigHistoryResponseModel };
